import clsx from "clsx";
import sprite from "../../../assets/images/icons.svg?no-inline";
import styles from "./Icon.module.scss";

interface IconProps {
  icon: string;
  className?: string;
  width?: number;
  height?: number;
  color?: string;
  onClick?: () => void;
}

const Icon = ({
  icon,
  className,
  width,
  height,
  color = "currentColor",
  onClick,
}: IconProps) => {
  return (
    <svg
      width={width}
      height={height}
      onClick={onClick}
      style={{ color }}
      className={clsx(styles.icon, className)}
    >
      <use xlinkHref={`${sprite}#${icon}`} />
    </svg>
  );
};

export default Icon;
